import type { PageField } from './pageContract';

export function validatePageFilters(changes: Record<string, unknown>, schema: Record<string, PageField>) {
  if (!changes || typeof changes !== 'object' || Array.isArray(changes)) throw new Error('Filters must be an object.');
  for (const [key, value] of Object.entries(changes)) {
    const field = Object.prototype.hasOwnProperty.call(schema, key) ? schema[key] : undefined;
    if (!field) throw new Error(`Unsupported filter: ${key}`);
    if (
      field.type === 'enum' &&
      (field.multiple
        ? typeof value !== 'string' || value.split(',').some((item) => !field.values?.includes(item.trim()))
        : !field.values?.includes(value as string))
    )
      throw new Error(`Invalid ${key}: use one of its declared values.`);
    if (
      field.multiple &&
      typeof value === 'string' &&
      field.maxSelections &&
      new Set(
        value
          .split(',')
          .map((item) => item.trim())
          .filter(Boolean),
      ).size > field.maxSelections
    )
      throw new Error(`${key} allows at most ${field.maxSelections} selections.`);
    if (field.type === 'text' && (typeof value !== 'string' || value.length > (field.maxLength ?? 200)))
      throw new Error(`${key} must be text of at most ${field.maxLength ?? 200} characters.`);
    if (field.type === 'boolean' && typeof value !== 'boolean') throw new Error(`${key} must be true or false.`);
    if (
      field.type === 'date' &&
      (typeof value !== 'string' ||
        !/^\d{4}-\d{2}-\d{2}$/.test(value) ||
        Number.isNaN(Date.parse(value)) ||
        new Date(value).toISOString().slice(0, 10) !== value)
    )
      throw new Error(`${key} must be a valid YYYY-MM-DD date.`);
  }
}

/** Multi-select edits settle by membership, independent of order or duplicate input. */
export function pageFilterValuesEqual(actual: unknown, requested: unknown, field?: PageField): boolean {
  if (field?.multiple && typeof actual === 'string' && typeof requested === 'string') {
    const canonical = (value: string) =>
      [
        ...new Set(
          value
            .split(',')
            .map((item) => item.trim())
            .filter(Boolean),
        ),
      ]
        .sort()
        .join(',');
    return canonical(actual) === canonical(requested);
  }
  return actual === requested;
}
